(function () {
  'use strict';

  if (window.RockEmPdpGallery) return;

  var state = {
    images: [],
    index: 0,
    title: ''
  };
  var requestVersion = 0;
  var imageLoads = new Map();

  function preloadImage(src) {
    if (!src || typeof window.Image !== 'function') return Promise.resolve(null);
    if (imageLoads.has(src)) return imageLoads.get(src).promise;
    var image = new window.Image();
    var entry = { image: image, ready: false };
    entry.promise = new Promise(function (resolve, reject) {
      image.onload = function () {
        var decoded = typeof image.decode === 'function' ? image.decode().catch(function () {}) : Promise.resolve();
        decoded.then(function () { entry.ready = true; resolve(image); });
      };
      image.onerror = function () {
        imageLoads.delete(src);
        reject(new Error('Unable to load product image'));
      };
    });
    imageLoads.set(src, entry);
    image.decoding = 'async';
    image.src = src;
    return entry.promise;
  }

  function whenImageReady(src, version, commit) {
    var cached = imageLoads.get(src);
    if (typeof window.Image !== 'function' || cached?.ready) {
      if (version === requestVersion) commit(cached?.image);
      return;
    }
    preloadImage(src).then(function (image) {
      if (version === requestVersion) commit(image);
    }, function () { /* Preserve the current gallery if the new image fails. */ });
  }

  function asArray(value) {
    if (Array.isArray(value)) return value;
    if (Array.isArray(value?.nodes)) return value.nodes;
    if (Array.isArray(value?.edges)) return value.edges.map(function (edge) { return edge?.node; });
    return [];
  }

  function imageUrl(image) {
    if (typeof image === 'string') return image;
    if (!image || typeof image !== 'object') return '';
    if (image.media_type && image.media_type !== 'image') return '';

    return image.src ||
      image.url ||
      image.originalSrc ||
      image.original_source ||
      image.secure_url ||
      image.preview_image?.src ||
      image.previewImage?.url ||
      image.image?.src ||
      image.image?.url ||
      image.node?.src ||
      image.node?.url ||
      '';
  }

  function absoluteUrl(value) {
    var url = String(value || '').trim();
    if (!url || url === '[object Object]') return '';
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  }

  function uniqueUrls(value) {
    var seen = new Set();
    return asArray(value).map(imageUrl).map(absoluteUrl).filter(function (url) {
      if (!url) return false;
      var key = url.replace(/^https?:/i, '').split('?')[0];
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function productImageGroups(product) {
    if (!product || typeof product !== 'object') return [];
    return [
      product.images,
      product.media,
      product.product?.images,
      product.product?.media
    ].map(uniqueUrls).filter(function (images) { return images.length; });
  }

  function collectImages(product, fallbackProduct) {
    var groups = productImageGroups(product).concat(productImageGroups(fallbackProduct));
    if (groups.length) {
      return groups.reduce(function (best, images) {
        return images.length > best.length ? images : best;
      }, []);
    }

    var featured = imageUrl(product?.featured_image) ||
      imageUrl(product?.featuredImage) ||
      imageUrl(product?.image) ||
      imageUrl(fallbackProduct?.featured_image) ||
      imageUrl(fallbackProduct?.featuredImage) ||
      imageUrl(fallbackProduct?.image);
    featured = absoluteUrl(featured);
    return featured ? [featured] : [];
  }

  function productHeroes() {
    return Array.from(document.querySelectorAll(
      '.tt-product-vertical-layout .zoom-product, .tt-product-single-img > .mediaimageholder .zoom-product'
    )).filter(function (image) {
      return !image.closest('[data-section-type="product-recommendations"]');
    });
  }

  function syncArrowVisibility() {
    document.querySelectorAll('#custom-product-item').forEach(function (controls) {
      var hasMultipleImages = state.images.length > 1;
      controls.classList.toggle('tt-show', hasMultipleImages);
      controls.hidden = !hasMultipleImages;
      controls.querySelectorAll('button').forEach(function (button) {
        button.disabled = !hasMultipleImages;
      });
    });
  }

  function select(index) {
    if (!state.images.length) return;

    var count = state.images.length;
    var nextIndex = ((Number(index) || 0) % count + count) % count;
    var src = state.images[nextIndex];
    whenImageReady(src, ++requestVersion, function () {
      state.index = nextIndex;
      window.onIndex = state.index;

      productHeroes().forEach(function (image) {
        image.src = src;
        image.setAttribute('data-zoom-image', src);
        if (state.title) image.alt = state.title;
        image.style.removeProperty('opacity');
        image.closest('.mediaimageholder')?.style.removeProperty('display');
      });

      document.querySelectorAll('#left-image-column img').forEach(function (image) {
        var selected = Number(image.dataset.index) === state.index;
        image.classList.toggle('is-selected', selected);
        image.setAttribute('aria-current', selected ? 'true' : 'false');
      });
    });
  }

  function rebuildDesktopThumbnails() {
    document.querySelectorAll('#left-image-column').forEach(function (column) { column.remove(); });

    document.querySelectorAll('.tt-product-vertical-layout').forEach(function (gallery) {
      gallery.classList.remove('rockem-gallery-synced');
    });

    var gallery = document.querySelector('.desktop-only .tt-product-vertical-layout') ||
      Array.from(document.querySelectorAll('.tt-product-vertical-layout')).find(function (element) {
        return element.offsetParent !== null;
      });
    if (!gallery || state.images.length < 2) return;

    var column = document.createElement('div');
    column.id = 'left-image-column';
    column.setAttribute('aria-label', 'Product images');

    state.images.forEach(function (url, index) {
      var wrapper = document.createElement('div');
      var image = document.createElement('img');
      wrapper.className = 'thumb';
      image.src = url;
      image.alt = state.title ? state.title + ' view ' + (index + 1) : 'Product view ' + (index + 1);
      image.dataset.index = index;
      wrapper.appendChild(image);
      column.appendChild(wrapper);
    });

    gallery.classList.add('rockem-gallery-synced');
    gallery.appendChild(column);
  }

  function rebuildMobileSliders() {
    document.querySelectorAll('.tt-mobile-product-slider').forEach(function (slider) {
      if (slider.closest('[data-section-type="product-recommendations"]')) return;

      var $slider = window.jQuery ? window.jQuery(slider) : null;
      if ($slider?.hasClass('slick-initialized') && typeof $slider.slick === 'function') {
        $slider.slick('unslick');
      }

      slider.replaceChildren();
      state.images.forEach(function (url, index) {
        var slide = document.createElement('div');
        var image = document.createElement('img');
        slide.className = 'rockem-product-image';
        var prepared = imageLoads.get(url)?.image || imageLoads.get(state.images[0])?.image;
        if (prepared?.naturalWidth && prepared?.naturalHeight) {
          image.width = prepared.naturalWidth;
          image.height = prepared.naturalHeight;
        }
        image.src = url;
        image.alt = state.title ? state.title + ' view ' + (index + 1) : 'Product view ' + (index + 1);
        slide.appendChild(image);
        slider.appendChild(slide);
      });

      if (window.innerWidth < 576 && state.images.length && typeof $slider?.slick === 'function') {
        $slider.slick({
          dots: slider.dataset.slickdots === 'true',
          arrows: true,
          infinite: false,
          fade: false,
          swipe: true,
          swipeToSlide: true,
          touchMove: true,
          draggable: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true
        });
      }
    });
  }

  function setProduct(product, fallbackProduct, options) {
    options = options || {};
    var images = collectImages(product, fallbackProduct);
    var version = ++requestVersion;
    // Early combinable descriptors may have no gallery. Leave the current
    // image, thumbnails, and mobile slides intact until full product data lands.
    if (!images.length) return [];
    whenImageReady(images[0], version, function () {
      state.images = images;
      state.index = 0;
      state.title = options.title || product?.title || fallbackProduct?.title || '';
      window.onIndex = 0;
      rebuildDesktopThumbnails();
      if (options.replaceMobile) rebuildMobileSliders();
      syncArrowVisibility();
      select(0);
    });

    return images.slice();
  }

  function prepareProduct(product, variant) {
    var first = collectImages(product)[0];
    var featured = absoluteUrl(imageUrl(variant?.featured_image));
    return Promise.all(Array.from(new Set([first, featured].filter(Boolean))).map(preloadImage));
  }

  function setImages(images, title, options) {
    return setProduct(
      { images: asArray(images), title: title || '' },
      null,
      Object.assign({}, options || {}, { title: title || '' })
    );
  }

  function step(amount) {
    if (state.images.length > 1) select(state.index + amount);
  }

  window.RockEmPdpGallery = {
    collectImages: collectImages,
    prepareProduct: prepareProduct,
    select: select,
    setImages: setImages,
    setProduct: setProduct,
    step: step
  };

  document.addEventListener('click', function (event) {
    var next = event.target.closest('#custom-product-item .slick-next');
    var previous = event.target.closest('#custom-product-item .slick-prev');
    var thumbnail = event.target.closest('#left-image-column img[data-index]');
    if (!next && !previous && !thumbnail) return;

    event.preventDefault();
    event.stopPropagation();

    if (thumbnail) select(Number(thumbnail.dataset.index));
    else step(next ? 1 : -1);
  }, true);
})();
